// Handle video hover playback on product cards
if (window.matchMedia('(min-width: 990px)').matches) {
  document.addEventListener('DOMContentLoaded', function() {
    const cardWrappers = document.querySelectorAll('.card-wrapper');

    cardWrappers.forEach(function(wrapper) {
      const video = wrapper.querySelector('.card__video');
      const image = wrapper.querySelector('.card__image');

      if (video && image) {
        let isHovering = false;

        // Try to preload video on first interaction
        wrapper.addEventListener('mouseenter', function() {
          isHovering = true;

          // Check if video has enough data to play smoothly
          if (video.readyState >= 3) { // HAVE_FUTURE_DATA or HAVE_ENOUGH_DATA
            video.play().then(() => {
              // Only hide image once video is actually playing
              image.style.opacity = '0';
            }).catch(() => {
              // If play fails, keep showing the image
              image.style.opacity = '1';
            });
          } else {
            // Video not ready, wait for it
            const playWhenReady = function() {
              if (isHovering) {
                video.play().then(() => {
                  image.style.opacity = '0';
                }).catch(() => {
                  image.style.opacity = '1';
                });
              }
              video.removeEventListener('canplay', playWhenReady);
            };
            video.addEventListener('canplay', playWhenReady);
          }
        }, { passive: true });

        wrapper.addEventListener('mouseleave', function() {
          isHovering = false;
          video.pause();
          video.currentTime = 0;
          // Show image again
          image.style.opacity = '1';
        }, { passive: true });
      }
    });
  });
}
